import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { SessionFormat } from '@app/api';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    height: theme.height.tiny,
    minWidth: theme.height.tiny,
    padding: 6,
    borderRadius: theme.height.tiny / 2,
    backgroundColor: theme.colors.yellowMuted,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    color: theme.colors.inkPrimary,
    fontSize: theme.iconSize.regular,
    marginRight: 6,
    '&:last-child': {
      marginRight: 0,
    },
  },
}));

interface Props {
  format: SessionFormat | SessionFormat[];
  className?: string;
}

export const getIconFromFormat = (format: SessionFormat): string => {
  switch (format) {
    case SessionFormat.PHONE_CALL:
      return 'ri-phone-line';
    case SessionFormat.PHYSICAL_MEETING:
      return 'ri-map-pin-2-line';
    case SessionFormat.VIDEO_CALL:
      return 'ri-vidicon-line';
    case SessionFormat.IN_PARTICIPANT_PLACE:
      return 'ri-walk-line';
    default:
      return '';
  }
};

interface SimpleIconProps {
  format: SessionFormat;
  className?: string;
}
export const FormatSimpleIcon = ({
  format,
  className,
  ...rest
}: SimpleIconProps) => (
  <i className={classnames(getIconFromFormat(format), className)} {...rest} />
);

export const FormatIcon = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });
  if (!props.format || !props.format.length) {
    return null;
  }
  return (
    <div className={classnames(classes.container, props.className)}>
      {typeof props.format === 'string' ? (
        <FormatSimpleIcon format={props.format} className={classes.icon} />
      ) : (
        props.format.map((singleFormat) => (
          <FormatSimpleIcon
            format={singleFormat}
            className={classes.icon}
            key={singleFormat}
          />
        ))
      )}
    </div>
  );
};
